import { Component, OnInit, AfterViewInit, OnChanges, SimpleChanges, ViewChild, ChangeDetectorRef  } from '@angular/core';
import { Mapapi } from '../ol-map/mapapi';

import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Draw from 'ol/interaction/Draw';
import Modify from 'ol/interaction/Modify';
import WKT from 'ol/format/WKT';

import { always, doubleClick } from 'ol/events/condition';

import { SelectItem } from 'primeng/api';
import { TabledataService } from '../_services/tabledata.service';
import { KeycloakService } from '../login/keycloak.service';
import { GlobalsService } from '../_services/globals.service';
import { LoginService } from '../login/login.service';
import { FormBuilder } from '@angular/forms';
import { LayersService } from 'app/_services/layers.service';
import { EventsService } from 'app/_services/events.service';

import { SearchService } from 'app/search/search.service';
import { ReportsService } from 'app/reports/reports.service';
import { RemotePowerService } from 'app/_services/remote-power.service';
import { APP_MODULE_ROLES } from 'app/enums/moduleRolesEnum';
import { MessageService } from 'primeng/api';

import Feature from 'ol/Feature';
import { Geometry } from 'ol/geom';
import { Style, Stroke, Fill } from 'ol/style';

import { DistrictHeatingService } from 'app/_services/district-heating.service';


@Component({
    selector: 'app-do-planning',
    templateUrl: './do-planning.component.html',
    styleUrls: ['./do-planning.component.css'],
    providers: [RemotePowerService],
    standalone: false
})
export class DoPlanningComponent implements OnInit, AfterViewInit, OnChanges {

  infoEvent: any;
  vectorDrawLayer: any;
  drawInteraction: any;
  doFindOptsSelected: number = 1;
  modifyInteraction: any;
  visibleDialogPlanning_1: boolean = false;
  visibleDialogPlanning_2: boolean = false;
  visibleDialogPlanning_3: boolean = false;
  midparameter: number;
  obmidsparameter: string;
  srchValueHsMid: '';

  drawopts: SelectItem[] = [{ label: 'Izberi', value: 1 }, { label: 'Popravi izbiro', value: 2 }, { label: 'Počisti izbiro', value: 3 }, { label: 'Zaključi', value: 4 }];
  drawoptselected: any;

  pptFindOpts: SelectItem[] = [{ label: 'Iskanje   primernega   območja', value: 1 }, { label: 'Lastna izbira območja', value: 2 }];
  pptFindOptsSelected: any = 1;
  

  rabeobjekta: SelectItem[] = [];
  selectedraba: any = -1;

  drawarea: boolean = false;
  
  plannings: any[] = [
    { label: 'Daljinsko ogrevanje', value: 1, disabled: !KeycloakService.auth.authz.realmAccess.roles.includes(APP_MODULE_ROLES.DALJINSKO) },
    { label: 'Sončne elektrarne', value: 2, disabled: !KeycloakService.auth.authz.realmAccess.roles.includes(APP_MODULE_ROLES.SONCNO) },
    { label: 'Toplotni sprejemniki sončne energije', value: 3, disabled: !KeycloakService.auth.authz.realmAccess.roles.includes(APP_MODULE_ROLES.TOPLOTNO) },
    { label: 'Sistemi daljinskega ogrevanja', value: 4, disabled: true }
  ];
  selectedplan: number | null = null;

  powerPlantTypes: SelectItem[] = [{ label: 'Samostoječe sončne elektrarne', value: 1 }, { label: 'Sončne elektrarne na strehah', value: 2 }];
  selectedPowerPlantType: any = 1


  roofTopPowerPlant: SelectItem[] = [{ label: 'Najdi po naslovu', value: 1 }, { label: 'Najdi ustrezne objekte', value: 2 }];
  selectedRoofTopPowerPlant: any = 1;

  ssLpeKwhkWp: SelectItem[] = [{ label: 'Letna proizvodnja električne energije [kWh]', value: 1 }, { label: 'Nazivna moč sončne elektrarne [kWp]', value: 2 }];
  ssLpeKwhkWpSelected: any = 1;

  ssRoofLocationOptionsPS: SelectItem[] = [{ label: 'Proizvodnja', value: 1 }, { label: 'Samooskrba', value: 2 }];
  ssRoofLocationOptionsPSSelected: any = 1;

  // za nov modul: sistemi daljinskega ogrevanja ---> RRI
  isZagorjeMunicipality: boolean = false;
  districtHeatingLayer: VectorLayer<VectorSource<Feature<Geometry>>> | null = null;
  districtHeatingSource: VectorSource<Feature<Geometry>> | null = null;

  districtHeatingHousesLayer: VectorLayer<VectorSource<Feature<Geometry>>> | null = null;
  districtHeatingHousesSource: VectorSource<Feature<Geometry>> | null = null;

  districtHeatingLegendNode: any = null;
  districtHeatingHousesLegendNode: any = null;

  powerPlantAreaSrchForm = this.formBuilder.group({

    areatype_dp: false,
    areatype_oei: false,
    areatype_ppo: false,
    minimalpowerMW: 1,
    buildings_allowed: false,
    maxLengthFromNearestRoadMeters: 500,
    maxLengthFromNearestTrafoStationMeters: 500,
    parcels_all: false,
    parcels_po: false,
    parcels_dp: false,
    parcels_op: false,
    rp_g: false,
    rp_psz: false,
    rp_soprp: false,
    rp_onrp: false,
    rp_v: false,
    maxParcelsOwners: 1

  });

  powerPlantRoofAddressSrchForm = this.formBuilder.group({
    proizvodnja: true,
    samooskrba: 0,
    typePs: 1

  });

  powerPlantRoofObjectSrchForm = this.formBuilder.group({
    raba: -1,
    lastnik_drzava: false,
    lastnik_obcina: false,
    lastnik_pravna_os: false,
    lastnik_fizicna_os: false,
    brez_kult_ded: true,
    tlp: 1,
    lp: 1000,
    ravna_s: false,
    max_rs_obj: 0,
    l_ob_str: 30,
    l_ob_obj: 30
  });

  constructor(private mApi: Mapapi, private tService: TabledataService, private kks: KeycloakService, 
    private ss: SearchService, private remotePowerService: RemotePowerService, private messageService: MessageService,
    private gs: GlobalsService, private ls: LoginService, private lys: LayersService, private formBuilder: FormBuilder, 
    private ees: EventsService, private districtHeatingService: DistrictHeatingService, private cdr: ChangeDetectorRef) {
      
  }
  ngOnChanges(changes: SimpleChanges): void {

  }

  doSelectPowerPlantType(e: any) {

  }

  doSelssRoofLocationOptionsPS(e: any) {
    let form = this.powerPlantRoofAddressSrchForm;
    form.get("proizvodnja").setValue((e.value) === 1);

    if (e.value === 1) {

      form.get("samooskrba").setValue(0);

    }
    console.log("oc", this.powerPlantRoofAddressSrchForm);
  }

  doSelLpeType(e: any) {


  }

  /*iskanje streh primernih streh po parametrih*/
  onSubmitPPORS() {
    const payload = {
      ...this.powerPlantRoofObjectSrchForm.getRawValue(),
      userId: KeycloakService.auth.authz.subject,
      mid: this.midparameter,
      mids: this.obmidsparameter
    };

    console.warn('Your data has been submitted', JSON.stringify(payload));
    this.messageService.add({ key: 'doPlanning', severity: 'info', summary: 'Obvestilo', detail: 'Analiza podatkov se je začela !' });

    this.tService
      .addNewData(this.gs.getRestUrl() + "/api/fotovoltaika/sesByParams", JSON.stringify(payload))
      .subscribe((r: any) => {

        console.log(r);
        this.showData(r);
        this.messageService.add({ key: 'doPlanning', severity: 'info', summary: 'Obvestilo', detail: r.msg });
        setTimeout(() => { this.messageService.clear(); }, 5000);

      }, (e) => {
        console.error("error", e);
        this.messageService.add({ key: 'doPlanning', severity: 'error', summary: 'Obvestilo', detail: e.message });
      });
  }

  /*iskanje streh po naslovu*/
  onSubmitPPARS() {
    const payload = {
      ...this.powerPlantRoofAddressSrchForm.getRawValue(),
      userId: KeycloakService.auth.authz.subject,
      mid: this.midparameter,
      mids: this.obmidsparameter,
      hsmid: this.srchValueHsMid
    };

    console.warn('Your data has been submitted', JSON.stringify(payload));
    this.messageService.add({ key: 'doPlanning', severity: 'info', summary: 'Obvestilo', detail: 'Analiza podatkov se je začela !' });

    this.tService
      .addNewData(this.gs.getRestUrl() + "/api/fotovoltaika/sesByAddress", JSON.stringify(payload))
      .subscribe((r: any) => {

        console.log("sesByAddress", r);
        this.showData(r);
        this.messageService.add({ key: 'doPlanning', severity: 'info', summary: 'Obvestilo', detail: r.msg });
        setTimeout(() => { this.messageService.clear(); }, 5000);

      }, (e) => {
        console.error("error", e);
        this.messageService.add({ key: 'doPlanning', severity: 'error', summary: 'Obvestilo', detail: e.message });
      });
  }

  onSubmitPPF() {
    const payload = {
      ...this.powerPlantAreaSrchForm.getRawValue(),
      userId: KeycloakService.auth.authz.subject,
      mid: this.midparameter,
      mids: this.obmidsparameter
    };

    console.warn('Your data has been submitted', JSON.stringify(payload));
    this.messageService.add({ key: 'doPlanning', severity: 'info', summary: 'Obvestilo', detail: 'Analiza podatkov se je začela !' });

    this.tService
      .addNewData(this.gs.getRestUrl() + "/api/fotovoltaika/sse", JSON.stringify(payload))
      .subscribe((r: any) => {

        console.log(r);
        this.showData(r);
        this.messageService.add({ key: 'doPlanning', severity: 'info', summary: 'Obvestilo', detail: r.msg });
        setTimeout(() => { this.messageService.clear(); }, 5000);

      }, (e) => {
        console.error("error", e);
        this.messageService.add({ key: 'doPlanning', severity: 'error', summary: 'Obvestilo', detail: e.message });
      });
  }

  private updatePlanningOptions(): void {
    const base = [
      { label: 'Daljinsko ogrevanje', value: 1, disabled: !KeycloakService.auth.authz.realmAccess.roles.includes(APP_MODULE_ROLES.DALJINSKO) },
      { label: 'Sončne elektrarne', value: 2, disabled: !KeycloakService.auth.authz.realmAccess.roles.includes(APP_MODULE_ROLES.SONCNO) },
      { label: 'Toplotni sprejemniki sončne energije', value: 3, disabled: !KeycloakService.auth.authz.realmAccess.roles.includes(APP_MODULE_ROLES.TOPLOTNO) }
    ];

    if (this.isZagorjeMunicipality) {
      base.push({ label: 'Sistemi daljinskega ogrevanja', value: 4, disabled: false });
    }

    this.plannings = base;
  }

  doPlan(value: number) {
    const opt = this.plannings.find(p => p.value === value);
    if (!opt || opt.disabled) return;

    this.infoEvent = null;

    // ZA NOV MODUL SISTEMI DALJINSKEGA OGREVANJA --> RRI
    if (value === 4) {
      this.loadDistrictHeatingData();

      setTimeout(() => {
        this.selectedplan = null;
        this.cdr.detectChanges();
      });

      return;
    }

    this.openTabMenue(opt);
  }


  onPlanningHide() {
    this.selectedplan = null;
  }

  private openTabMenue(e: any) {
    if (e.disabled) return;

    this.visibleDialogPlanning_1 = e.value === 1;
    this.visibleDialogPlanning_2 = e.value === 2;
    this.visibleDialogPlanning_3 = e.value === 3;
  }

  public dlg_1Hide(e) {
    this.messageService.clear();
    this.ees.emitCancleDrawEvent(true);
    const foundNode = this.lys.findNodeById("291");
    this.mApi.getLayerById(foundNode.data.id).set("showinfo", true);
    this.vectorDrawLayer.getSource().clear();
    this.visibleDialogPlanning_1 = false;
    this.selectedplan = null;
  }

  public dlg_2Hide(e) {
    this.messageService.clear();
    this.vectorDrawLayer.getSource().clear();
    this.drawInteraction.setActive(false);
    this.modifyInteraction.setActive(false);
    this.visibleDialogPlanning_2 = false;
    this.selectedplan = null;
  }

  pptFindOptsAction(d: any) {

  }

  public drawAction(d: any, i: number) {
    this.messageService.clear();
    let sel = d.value;
    console.warn("DRAW ACTIN", d)
    if (sel === 1) {
      this.drawInteraction.setActive(true);
      this.modifyInteraction.setActive(false);
    }
    else if (sel === 2) {
      this.drawInteraction.setActive(false);
      this.modifyInteraction.setActive(true);
    }
    else if (sel === 3) {
      this.drawInteraction.setActive(false);
      this.modifyInteraction.setActive(false);
      this.vectorDrawLayer.getSource().clear();
    }
    else if (sel === 4) {
      this.drawInteraction.setActive(false);
      this.modifyInteraction.setActive(false);
      var features = this.vectorDrawLayer.getSource().getFeatures();


      if (features.length > 0) {
        this.messageService.add({ key: 'doPlanning', severity: 'info', summary: 'Obvestilo', detail: 'Zahteva za analizo je bila podana !' });
        var poly = features[0].getGeometry();
        const format = new WKT();
        const wktRepresenation = format.writeGeometry(poly);  

        var rBody = { mid: this.midparameter, mids: this.obmidsparameter, wktGeom: wktRepresenation, userId: KeycloakService.auth.authz.subject, geomSrid: this.mApi.map.getView().getProjection().getCode().split(":")[1] };


        this.vectorDrawLayer.getSource().clear();
        //console.log(JSON.stringify(rBody));
        let url = "";
        if (i === 1) url = this.gs.getRestUrl() + "/api/planiranjeDaljinskoOgrevanje/getBuildingsInsidePolygon";
        if (i === 2) url = this.gs.getRestUrl() + "/api/fotovoltaika/ssearea";

        this.messageService.add({ key: 'doPlanning', severity: 'info', summary: 'Obvestilo', detail: 'Analiza podatkov se je začela !' });

        this.tService.addNewData(url, JSON.stringify(rBody)).subscribe((r: any) => {

          console.log(r);
          // this.showData(r);
          if (r.isValidGeom !== undefined && !r.isValidGeom) {
            this.messageService.add({ key: 'doPlanning', severity: 'error', summary: 'Obvestilo', detail: r.msg });
          }
          else {
            this.messageService.add({ key: 'doPlanning', severity: 'info', summary: 'Obvestilo', detail: r.msg });
            //this.mApi.createWfsLayer(this.gs.getKartoGeoserverUrl(),r.geoserverLayerName,"sse",r.cql,true,true);
            if (i === 2) {
              this.showData(r);
            }
            setTimeout(() => { this.messageService.clear(); }, 5000)
          }


        }, (e) => {
          console.error("error", e);
          this.messageService.add({ key: 'doPlanning', severity: 'error', summary: 'Obvestilo', detail: e.message });
        });

      }
      else {
        this.messageService.add({ key: 'doPlanning', severity: 'error', summary: 'Obvestilo', detail: 'Za zaključek je potrebno vrisati območje analize !' });
      }

    }
  }

  private showData(r: any): void {

    if (r.status === true) {
      let tabels = [];
      if (r.dependendLayerIds) {
        tabels = tabels.concat(r.dependendLayerIds);
      }
      tabels.push(r.webappLayerId);


      tabels.forEach(id => {

        let node = this.lys.findNodeById(id);
        if (node !== null) {
          this.ees.sendTreeNodeOnOffEvt({ id: id, ison: true });
          node.data.showtable = true;
          node.data.tabledataloaded = false;
          this.tService.setRequestTableData(node);
          var s1 = this.tService.subscribeDataListener().subscribe(data => {
            s1.unsubscribe();
            this.tService.setShowTable(node.data.id, true, node.label, node);
          });
          //console.log("find node in tree",node);
        }
      });
    }
  }

  roofTopPowerPlantMode(e) {

  }

  ngAfterViewInit() {
    this.mApi.onMapLoad().subscribe(() => {

      this.vectorDrawLayer = new VectorLayer({
        source: new VectorSource()
      });

      this.mApi.map.addLayer(this.vectorDrawLayer);

      this.drawInteraction = new Draw({
        source: this.vectorDrawLayer.getSource(),
        type: 'Polygon',
        condition: always
      });

      this.modifyInteraction = new Modify({
        source: this.vectorDrawLayer.getSource(),
        condition: always,
        deleteCondition: (event) => doubleClick(event)
      });

      this.drawInteraction.on('drawstart', () => {
        this.vectorDrawLayer.getSource().clear();
      });

      this.drawInteraction.on('drawend', (event: any) => {
        const polygon = event.feature.getGeometry();
        console.log(polygon);
        console.log(event);
      });

      this.mApi.map.addInteraction(this.drawInteraction);
      this.mApi.map.addInteraction(this.modifyInteraction);

      this.drawInteraction.setActive(false);
      this.modifyInteraction.setActive(false);
    });
  }

  onSelectectedSrch(r) {

    this.srchValueHsMid = r[0]._hs_mid;
    console.log(r)
  }

  onClsoeDialog(event){
    this.visibleDialogPlanning_1 = event.open;
    this.messageService.add({ key: 'doPlanning', ...event.msg });
  }

  ngOnInit() {
    this.rabeobjekta.push({ label: 'Vsi', value: 1 });
    this.tService.getData(this.gs.getRestUrl() + "/api/fotovoltaika/sifnamobj", true).subscribe((r: any) => r.flatMap(i => {

      this.rabeobjekta.push({ label: i.opis, value: i.sifra });

    }));

    this.ees.listenOnEditArea().subscribe(event => {
      this.openTabMenue({value: 1});
      this.doFindOptsSelected = 2;
      this.infoEvent = event;
      const foundNode = this.lys.findNodeById("291")
      this.mApi.getLayerById(foundNode.data.id).set("showinfo", false); 
    })

    console.warn("KEYCLOAK SERVICE", KeycloakService.auth.authz.realmAccess.roles.includes(APP_MODULE_ROLES.DALJINSKO))

    this.lys.subscribeLayersGroupLoadListener().subscribe(
      data => {
        if (data.ob_mid !== undefined) {
          // console.log("load layer group ob mid:"+data.ob_mid);
          console.log("pc!!", data);

          this.obmidsparameter = data.ob_mids;
          this.midparameter = data.ob_mid;

          this.isZagorjeMunicipality = Number(data.ob_mid) === 11027679;

          this.updatePlanningOptions();

          if (!this.isZagorjeMunicipality) {
            this.selectedplan = null;
            this.hideDistrictHeatingEverywhere();
          }

        }
        else {
          console.log("load layer group error: data undefined ");

        }
      },
      err => { console.log(err) }

    );

    this.ees.subscribeMidChangeEvtListener().subscribe(() => {
      this.hideDistrictHeatingEverywhere();
    });

    this.ees.subscribeNodeUnSelectListener().subscribe((node: any) => {
      const isDistrictHeating =
        node?.data?.id === 'district-heating-lines' ||
        node?.data?.id === 'district-heating-houses';

      if (!isDistrictHeating) {
        return;
      }

      this.removeDistrictHeatingLayersOnly();

      this.districtHeatingLegendNode = null;
      this.districtHeatingHousesLegendNode = null;
      this.selectedplan = null;
    });

  }



  // ------------------------------------------------------------------------------------------------------//
  //-----------------------------------------NOV MODUL-----------------------------------------------------//
  //-----------------------------------SISTEMI DALJINSKEGA OGREVANJA---------------------------------------//
  // ------------------------------------------------------------------------------------------------------//

  private renderDistrictHeatingHouses(data: any[]): void {
    if (!this.districtHeatingHousesSource) {
      this.districtHeatingHousesSource = new VectorSource<Feature<Geometry>>();

      this.districtHeatingHousesLayer = new VectorLayer({
        source: this.districtHeatingHousesSource,
        style: new Style({
          stroke: new Stroke({
            color: '#ff9800',
            width: 3
          }),
          fill: new Fill({
            color: 'rgba(255, 153, 0, 0.65)'
          })
        })
      });

      this.districtHeatingHousesLayer.set('id', 'district-heating-houses');
      this.districtHeatingHousesLayer.set('showinfo', true);
      this.districtHeatingHousesLayer.set('selectable', true);
      this.districtHeatingHousesLayer.set('dynamic', 'false');
      this.districtHeatingHousesLayer.setVisible(true);
      this.districtHeatingHousesLayer.setZIndex(100000);

      this.mApi.map.addLayer(this.districtHeatingHousesLayer);
    }

    this.districtHeatingHousesSource.clear();

    const format = new WKT();

    const features: Feature<Geometry>[] = (data ?? [])
      .filter(item => !!item?.geom)
      .map(item => {
        const feature = format.readFeature(item.geom, {
          dataProjection: 'EPSG:3794',
          featureProjection: this.mApi.map.getView().getProjection().getCode()
        }) as Feature<Geometry>;

        const stavbaId = item?.stavbaId ?? item?.stavba_id;
        const sistemId = item?.sistemId ?? item?.sistem_id;
        const stStavbe = item?.stStavbe ?? item?.st_stavbe;
        const obMid = item?.obMid ?? item?.ob_mid;
        const koId = item?.koId ?? item?.ko_id;

        feature.setProperties({
          ...item,
          stavbaId,
          sistemId,
          stStavbe,
          obMid,
          koId
        });

        feature.set('layerID', 'district-heating-houses');
        feature.set('showinfo', true);
        feature.set('stavbaId', stavbaId);
        feature.set('sistemId', sistemId);
        feature.set('stStavbe', stStavbe);

        feature.setId(`district-heating-houses.${stavbaId ?? 'x'}.${sistemId ?? 'x'}`);

        return feature;
      });

    this.districtHeatingHousesSource.addFeatures(features);
  }


  private loadDistrictHeatingData(): void {
    const municipalityId = this.midparameter;

    this.clearDistrictHeatingSystems();

    console.log('loadDistrictHeatingData municipalityId =', municipalityId);

    this.districtHeatingService.getSystems(municipalityId).subscribe({
      next: (systems: any[]) => {
        console.log('SYSTEMS RESPONSE', systems);
        this.renderDistrictHeatingSystems(systems ?? []);

        this.districtHeatingService.getHouses(municipalityId).subscribe({
          next: (houses: any[]) => {
            console.log('HOUSES RESPONSE', houses);
            this.renderDistrictHeatingHouses(houses ?? []);

            this.districtHeatingLegendNode = this.buildDistrictHeatingLegendNode();
            this.districtHeatingHousesLegendNode = this.buildDistrictHeatingHousesLegendNode();

            this.ees.sendSelectNode(this.districtHeatingLegendNode);
            this.ees.sendSelectNode(this.districtHeatingHousesLegendNode);

            setTimeout(() => this.messageService.clear('doPlanning'), 3000);
          },
          error: (e) => {
            console.error('GET HOUSES ERROR', e);
            this.messageService.add({
              key: 'doPlanning',
              severity: 'error',
              summary: 'Napaka',
              detail: 'Napaka pri nalaganju stavb daljinskega ogrevanja.'
            });
          }
        });
      },
      error: (e) => {
        console.error('GET SYSTEMS ERROR', e);
        this.messageService.add({
          key: 'doPlanning',
          severity: 'error',
          summary: 'Napaka',
          detail: 'Napaka pri nalaganju sistemov daljinskega ogrevanja.'
        });
      }
    });
  }

  private renderDistrictHeatingSystems(data: any[]): void {
    if (!this.districtHeatingSource) {
      this.districtHeatingSource = new VectorSource<Feature<Geometry>>();

      this.districtHeatingLayer = new VectorLayer({
        source: this.districtHeatingSource,
        style: new Style({
          stroke: new Stroke({
            color: '#ff6b6b',
            width: 3
          })
        })
      });

      this.districtHeatingLayer.set('id', 'district-heating-lines');
      this.districtHeatingLayer.set('showinfo', true);
      this.districtHeatingLayer.set('selectable', true);   // IMPORTANT
      this.districtHeatingLayer.set('dynamic', 'false');
      this.districtHeatingLayer.setVisible(true);
      this.districtHeatingLayer.setZIndex(99999);

      this.mApi.map.addLayer(this.districtHeatingLayer);
    }

    this.districtHeatingSource.clear();

    const format = new WKT();

    const features: Feature<Geometry>[] = (data ?? [])
      .filter(item => !!item?.geom)
      .map(item => {
        const feature = format.readFeature(item.geom, {
          dataProjection: 'EPSG:3794',
          featureProjection: this.mApi.map.getView().getProjection().getCode()
        }) as Feature<Geometry>;

        // SAME DATA TABLE / INFO DATA AS BEFORE
        feature.setProperties({
          ...item
        });

        feature.set('layerID', 'district-heating-lines');
        feature.set('showinfo', true);

        if (item?.sistemId != null) {
          feature.set('sistemId', item.sistemId);
          feature.setId(`district-heating-lines.${item.sistemId}`);
        }

        return feature;
      });

    this.districtHeatingSource.addFeatures(features);
  }

  private removeDistrictHeatingLayersOnly(): void {
    if (this.districtHeatingLayer) {
      this.mApi.unselectFeatureForLayer(this.districtHeatingLayer);
    }

    if (this.districtHeatingSource) {
      this.districtHeatingSource.clear();
    }

    if (this.districtHeatingLayer) {
      this.mApi.map.removeLayer(this.districtHeatingLayer);
      this.districtHeatingLayer = null;
    }

    this.districtHeatingSource = null;

    if (this.districtHeatingHousesLayer) {
      this.mApi.unselectFeatureForLayer(this.districtHeatingHousesLayer);
    }

    if (this.districtHeatingHousesSource) {
      this.districtHeatingHousesSource.clear();
    }

    if (this.districtHeatingHousesLayer) {
      this.mApi.map.removeLayer(this.districtHeatingHousesLayer);
      this.districtHeatingHousesLayer = null;
    }

    this.districtHeatingHousesSource = null;
  }

  private clearDistrictHeatingSystems(): void {
    this.removeDistrictHeatingLayersOnly();

    if (this.districtHeatingLegendNode) {
      this.districtHeatingLegendNode.selected = false;
      this.ees.sendUnSelectNode(this.districtHeatingLegendNode);
      this.districtHeatingLegendNode = null;
    }

    if (this.districtHeatingHousesLegendNode) {
      this.districtHeatingHousesLegendNode.selected = false;
      this.ees.sendUnSelectNode(this.districtHeatingHousesLegendNode);
      this.districtHeatingHousesLegendNode = null;
    }
  }

  private getDistrictHeatingLegend(): string {
    const svg = `
      <svg xmlns="http://www.w3.org/2000/svg" width="220" height="50">
        <line x1="5" y1="14" x2="35" y2="14" stroke="#ff6b6b" stroke-width="4"/>
        <text x="45" y="18"
          font-family="Segoe UI, Roboto, Arial, sans-serif"
          font-size="12"
          font-weight="600"
          fill="#8a8f98">Sistem DO</text>

        <line x1="5" y1="34" x2="35" y2="34" stroke="#ff9800" stroke-width="4"/>
        <text x="45" y="38"
          font-family="Segoe UI, Roboto, Arial, sans-serif"
          font-size="12"
          font-weight="600"
          fill="#8a8f98">Stavbe v SDO</text>
      </svg>
    `;
    return 'data:image/svg+xml;utf8,' + encodeURIComponent(svg);
  }

  private buildDistrictHeatingLegendNode(): any {
    return {
      label: 'Sistemi daljinskega ogrevanja',
      fulllabel: 'Sistemi daljinskega ogrevanja',
      selected: true,
      data: {
        id: 'district-heating-lines',
        type: 'custom',
        showlegend: true,
        legend: this.getDistrictHeatingLegend(),
        info: true,
        ison: true,
        removeLayerDetailView: false,
        aclass: 'activeLayer'
      }
    };
  }

  private buildDistrictHeatingHousesLegendNode(): any {
    return {
      label: 'Stavbe daljinskega ogrevanja',
      fulllabel: 'Stavbe daljinskega ogrevanja',
      selected: true,
      data: {
        id: 'district-heating-houses',
        type: 'custom',
        showlegend: false,
        legend: null,
        info: true,
        ison: true,
        removeLayerDetailView: false,
        aclass: 'activeLayer'
      }
    };
  }

  private hideDistrictHeatingEverywhere(): void {
    this.clearDistrictHeatingSystems();
  }

}
